<div fxLayout.xs="column">
<div>
    <mat-form-field>
        <mat-label>{{labeltext || 'Region'}}</mat-label>
        <mat-select [(ngModel)]="value" [(value)]="value"
                    (openedChange)="onOpen($event)"
                    [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
                    name="stateId"
                    [typeaheadDebounceInterval]="300"
                    (selectionChange)="onStateChange($event)"
                    [compareWith]="objectComparison"
                    #stateId = "ngModel"
                    [disabled]="isDisabled"
                    [required]="isRequired">
            <mat-option *ngIf="items === null || !items?.length" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option [value]="-1" *ngIf="alltext && !isLoading">
                {{alltext}}
            </mat-option>
            <mat-option [value]="item"
                        *ngFor="let item of items">{{item.Name}}
            </mat-option>
        </mat-select>
        <mat-error class="md-errormsg" *ngIf="!stateId.valid && stateId.touched && isRequired">Required</mat-error>
    </mat-form-field >
    <mat-icon fxFlexAlign.lt-md="center" *ngIf="ShowHelp" matToolTip="helptext" matTooltipPosition="above">
        help
    </mat-icon>
</div>
    <mat-error  class="sm-errormsg"*ngIf="!stateId.valid && stateId.touched && isRequired">Required</mat-error>

</div>




